import { useLingui } from '@lingui/react';
import { useAppConfiguration } from '@wkda/funnel-components';
export const useMinimumMileageValidation = () => {
  const {
    i18n
  } = useLingui();
  // @ts-ignore
  const {
    minimumMileage
  } = useAppConfiguration();
  return {
    createCustomValidators: [function mileageValidator({
      validators
    }) {
      return {
        ...validators,
        mileage({
          value,
          errorMessages,
          values
        }) {
          const {
            builtDate
          } = values;
          const maxMileageValue = 999999999;
          const minMileageValue = 0;
          if (minimumMileage && isMileageInvalidForYear(builtDate, value)) {
            return i18n._('carleadCreation.error.minimumMileage');
          }
          if (mileageIsOutOfBounds(value)) {
            return errorMessages.tooLongMileage;
          }
          return notEmpty(value) && Number(value) > minMileageValue && Number(value) <= maxMileageValue || errorMessages.mileage;
        }
      };
    }]
  };
};
function isEmpty(value = '') {
  // eslint-disable-next-line eqeqeq
  return value == undefined || value === '';
}
function notEmpty(value = '') {
  return !isEmpty(value);
}
function mileageIsOutOfBounds(mileage = '') {
  const maxMileageValue = 999999999;
  if (notEmpty(mileage) && Number(mileage) > maxMileageValue) {
    return true;
  }
  return false;
}
function isMileageInvalidForYear(builtDate = '', mileage = '') {
  const currentYear = new Date().getFullYear();
  const builtYear = parseInt(builtDate, 10);
  // Custom validation logic
  if (builtYear < currentYear - 1 && parseInt(mileage, 10) < 1000) {
    return true;
  }
  return false;
}